module.exports = __webpack_public_path__ + "static/media/ThankYouGIF.b1ce3e9b.gif";